























import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import TopNavBar from './components/Navigation/TopNavBar.vue'
import Login from './components/Login.vue'
import userModule from './store/modules/UserModule'
import salesOrgModule from './store/modules/SalesOrgsModule'
import Copyright from './components/Copyright.vue'

@Component({
  components: {
    TopNavBar,
    Login,
    Copyright
  }
})
export default class AppComponent extends Vue {
  public pageActive = '';
  public updatePage (page: string) {
    this.pageActive = page
  }

  public get userId () {
    return userModule.id
  }

  public get connected () {
    return userModule.token.length > 0
  }

  public get salesOrgIsLoading () {
    return salesOrgModule.isLoading
  }

  public updateToken (param: any) {
    userModule.updateToken(param.token)
    userModule.updateUser(param.user)
    userModule.loadSurrogacies()
  }

  public displayToken () {
    return userModule.token
  }

  @Watch('connected', { immediate: true })
  public loadSalesOrg () {
    salesOrgModule.loadAllSalesOrg()
  }
}
